export default "__VITE_ASSET__7dc43dd8__"